export default __webpack_public_path__ + "static/media/your-baby-report.0c91376c.png";